import './styles.scss'
import './CreateAccount.module.scss'
import { stepsStoreConfig } from '../../../entities/Stepper2Mexico/config/CF/stepsStoreConfig'
import { Store, useStore } from '../../../entities/Stepper2Mexico/module/rootStore'
import Stepper from '../../../entities/Stepper2Mexico/ui/Stepper'
import createApiFunctions from '../../../entities/Stepper2Mexico/api/factoryApi'
import { apiConfig } from '../../../entities/Stepper2Mexico/config/CF/apiConfig'

console.log('123')
const stepsStoreApi = createApiFunctions({
  apiConfig,
  abTest: 'b',
  // isTest: true
})

Store.setConfig({
  stepsStoreConfig,
  stepsStoreApi
})

const CreateAccount = () => {

  return (
    <Stepper />
  )
}

export default CreateAccount